import React from 'react';
import { Button, Typography, Card, List } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph, Text } = Typography;

const MediaPermissionInstruction = ({ onClick }) => {
  const { t } = useTranslation('common');

  const steps = t('media_permission.steps', { returnObjects: true });
  const importantPoints = t('media_permission.important_points', { returnObjects: true });

  return (
    <Card style={{ maxWidth: '75%', margin: 'auto', padding: '32px' }}>
      <Typography>
        <Title level={3}>{t('media_permission.title')}</Title>

        <Paragraph>{t('media_permission.description')}</Paragraph>

        <List
          size="small"
          bordered={false}
          dataSource={steps}
          renderItem={(item, index) => (
            <List.Item
              style={{
                textAlign: 'justify',
                paddingLeft: 0,
                alignItems: 'flex-start',
                borderBottom: 'none',
              }}
            >
              <div style={{ display: 'flex', textAlign: 'justify' }}>
                <span style={{ minWidth: '20px' }}>{index + 1}.</span>
                <span style={{ flex: 1, textAlign: 'justify' }}>{item}</span>
              </div>
            </List.Item>
          )}
          style={{ marginBottom: 24 }}
        />

        <Title
          level={4}
          style={{ textAlign: 'left' }}
        >
          {t('media_permission.important_title')}
        </Title>

        <List
          size="small"
          bordered={false}
          dataSource={importantPoints}
          renderItem={item => (
            <List.Item
              style={{
                textAlign: 'justify',
                paddingLeft: 0,
                alignItems: 'flex-start',
                borderBottom: 'none',
              }}
            >
              <div style={{ display: 'flex', textAlign: 'justify' }}>
                <span style={{ minWidth: '20px' }}>•</span>
                <span style={{ flex: 1, textAlign: 'justify' }}>{item}</span>
              </div>
            </List.Item>
          )}
        />

        <Paragraph style={{ marginTop: 24 }}>
          <Text strong>{t('media_permission.need_help')}</Text> {t('media_permission.support_text')}{' '}
          <Text type="secondary">{t('media_permission.support_contact')}</Text>
        </Paragraph>

        <Button
          type="primary"
          size="large"
          onClick={onClick}
          style={{ marginTop: 32 }}
        >
          {t('media_permission.cta')}
        </Button>
      </Typography>
    </Card>
  );
};

export default MediaPermissionInstruction;
